import BaseDataProcessor from './baseDataProcessor';
import { getOrdinal } from '../../../../../utilities/numbers';

export default class GroupPerformanceDataProcessor extends BaseDataProcessor {
  constructor(apiStatisticsData, interval) {
    super();

    this.apiStatisticsData = apiStatisticsData;
    this.interval = interval;
  }

  get apiData() {
    return this.apiStatisticsData;
  }

  get data() {
    if (this.apiStatisticsData) {
      return [{ primaryText: getOrdinal(this.apiStatisticsData.position), secondaryText: 'group rank' }];
    } else {
      return [];
    }
  }

  get topPerformers() {
    if(this.apiStatisticsData) {
      if(!this.apiStatisticsData.topPerformers) {
        return [];
      }

      return [].concat(...this.apiStatisticsData.topPerformers.map(group => group.members)) || [];
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/dataProcessors/groupPerformanceDataProcessor.js